import lPrompt from '@/components/l-prompt'
import { lLoading } from '@/components/l-loading'
import LHTTP from '@dayuan/service-http'
const baseApi = '/api'

export default class HTTP extends LHTTP {
  constructor () {
    super({
      options: {
        baseApi: baseApi,
        timeout: 60000
      },
      defaultHeaders: {
        source: process.env.VUE_APP_TYPE, // 系统类型
        'Content-Type': 'application/json;charset=UTF-8'
      }
    })
  }

  request (config) {
    return new Promise((resolve, reject) => {
      lLoading.show('数据加载...')

      this.service(config)
        .then(res => {
          if (res.status === this.HTTPSTATUS.SUCCESS) {
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(error => {
          lPrompt({
            message: error.message,
            successTxt: '确定',
            successFn: function () {
              location.reload()
            }
          })
          reject(null)
        })
        .finally(() => {
          lLoading.hide()
        })
    })
  }
}
